import React, { useState, useEffect } from 'react'
// @ts-ignore
import ToggleButton from 'react-toggle-button'
import styles from '../component-styles/calendar-filters.module.scss'
import Arrow from '../svgs/arrow'

interface Props {
  events: boolean
  onEventsToggle: () => void
  anomalies: boolean
  onAnomaliesToggle: () => void
  campaigns: boolean
  onCampaignsToggle: () => void
  day: Date | null
}

export default function Filters({
  events,
  onEventsToggle,
  anomalies,
  onAnomaliesToggle,
  campaigns,
  onCampaignsToggle,
  day,
}: Props): React.ReactElement | null {
  const [active, setActive] = useState(false)

  useEffect((): void => {
    setActive(false)
  }, [day])

  return (
    <div className={styles.container}>
      <div
        className={styles.row}
        onClick={(): void => setActive(!active)}
        onKeyDown={(): void => setActive(!active)}
        role="button"
        tabIndex={-1}
      >
        <h3>
          Filters
          <Arrow className={active ? styles.upArrow : styles.downArrow} />
        </h3>
      </div>
      <div
        className={active ? styles.toggleBoxOpen : styles.toggleBoxClosed}
        aria-label={active ? 'visible' : 'hidden'}
      >
        <div
          className={styles.row}
          aria-labelledby="toggle button for anomalies"
        >
          <h3>Anomalies</h3>
          <ToggleButton
            onToggle={onAnomaliesToggle}
            value={anomalies}
            colors={{
              active: {
                base: '#E61969',
                hover: '#E61969',
              },
            }}
          />
        </div>
        <div className={styles.row} aria-labelledby="toggle button for events">
          <h3>Events</h3>
          <ToggleButton
            onToggle={onEventsToggle}
            value={events}
            colors={{
              active: {
                base: '#007D9B',
                hover: '#007D9B',
              },
            }}
          />
        </div>
        <div
          className={styles.row}
          aria-labelledby="toggle button for campaigns"
        >
          <h3>Campaigns</h3>
          <ToggleButton
            onToggle={onCampaignsToggle}
            value={campaigns}
            colors={{
              active: {
                base: '#FFD70F',
                hover: '#FFD70F',
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}
